module.exports = __webpack_public_path__ + "static/media/winner_1.dc45a66b.png";